var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Icon, Inset, InlineChildren, Text, withTheming, StackChildren, Colors, Spacing, } from '@doordash/design-language';
import { IconButton } from '@doordash/component-button';
import styled from 'styled-components';
export var BannerType;
(function (BannerType) {
    BannerType["WARNING"] = "WARNING";
    BannerType["ERROR"] = "ERROR";
    BannerType["INFORMATIONAL"] = "INFORMATIONAL";
    BannerType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    BannerType["SUCCESS"] = "SUCCESS";
})(BannerType || (BannerType = {}));
var InfoBannerStrings = {
    close: function () { return 'Close'; },
};
var getBannerBackgroundColor = function (theme, bannerType) {
    var backgroundColor;
    switch (bannerType) {
        case BannerType.WARNING:
            backgroundColor = theme.Colors.BannerWarningBackground;
            break;
        case BannerType.ERROR:
            backgroundColor = theme.Colors.BannerNegativeBackground;
            break;
        case BannerType.INFORMATIONAL:
            backgroundColor = theme.Colors.BannerDefaultBackground;
            break;
        case BannerType.SUCCESS:
            backgroundColor = theme.Colors.BannerPositiveDefaultBackground;
            break;
        case BannerType.ANNOUNCEMENT:
            backgroundColor = theme.Colors.BannerInformationalSubduedBackground;
            break;
        default:
            backgroundColor = theme.Colors.BannerDefaultBackground;
            break;
    }
    return backgroundColor;
};
var getBannerIcon = function (bannerType) {
    var bannerIconType;
    var bannerIconColor;
    switch (bannerType) {
        case BannerType.WARNING:
            bannerIconType = Icon.Types.WarningFill;
            bannerIconColor = Icon.Colors.BannerWarningIcon;
            break;
        case BannerType.ERROR:
            bannerIconType = Icon.Types.ErrorFill;
            bannerIconColor = Icon.Colors.BannerNegativeIcon;
            break;
        case BannerType.INFORMATIONAL:
            bannerIconType = Icon.Types.InfoCircleLine;
            break;
        case BannerType.ANNOUNCEMENT:
            bannerIconType = Icon.Types.LogoDoordash;
            bannerIconColor = Icon.Colors.SystemRed60;
            break;
        case BannerType.SUCCESS:
            bannerIconType = Icon.Types.CheckCircleLine;
            bannerIconColor = Icon.Colors.SystemGreen70;
            break;
        default:
            bannerIconType = Icon.Types.InfoCircleLine;
            break;
    }
    return React.createElement(Icon, { type: bannerIconType, color: bannerIconColor });
};
var BannerContainer = withTheming(styled(Inset).attrs(function () { return ({
    size: Inset.Sizes.Small,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  ", ";\n"], ["\n  background-color: ",
    ";\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme, bannerType = _a.bannerType;
    return getBannerBackgroundColor(theme, bannerType);
}, function (_a) {
    var bannerType = _a.bannerType;
    if (bannerType === BannerType.ANNOUNCEMENT) {
        return "\n      box-shadow: 0px " + Spacing.XxxSmall + "px " + Spacing.Medium + "px rgba(0, 0, 0, 0.08);\n      border-radius: " + Spacing.XxxSmall + "px;\n      ";
    }
    return "";
}));
var InfoBanner = function (_a) {
    var justification = _a.justification, bannerText = _a.bannerText, bannerType = _a.bannerType, bannerTitle = _a.bannerTitle, onClose = _a.onClose, testId = _a.testId;
    var bannerContentJustification = justification
        ? justification
        : InlineChildren.Justification.SpaceBetween;
    return (React.createElement(BannerContainer, { bannerType: bannerType, "data-testid": testId },
        React.createElement(InlineChildren, { size: InlineChildren.Sizes.Small, justifyContent: bannerContentJustification },
            getBannerIcon(bannerType),
            React.createElement(StackChildren, { size: StackChildren.Sizes.XxSmall },
                bannerTitle && (React.createElement(Text, { styles: Text.Styles.BannerLabel }, bannerTitle)),
                bannerText && (React.createElement(Text, { styles: Text.Styles.Medium16 }, bannerText))),
            onClose && (React.createElement(IconButton, { iconType: IconButton.IconTypes.Close, type: IconButton.Types.FlatSecondary, size: IconButton.Sizes.Small, color: Colors.ButtonPrimaryBackground, accessibilityLabel: InfoBannerStrings.close(), onClick: onClose })))));
};
export default InfoBanner;
var templateObject_1;
